export interface ICountdownTimer {
	onComplete?: () => void;
	colorChange?: boolean | { start: string; middle: string; end: string };
	size?: number;
	format?: 'ss' | 'mm:ss' | 'hh:mm:ss';
	strokeWidth?: number;
	start?: boolean;
	duration: number;
	persistCountDown?: boolean;
	countDownId: string;
}

export const COUNTDOWNCOLORS = {
	GREEN: '#22c55e',
	YELLOW: '#eab308',
	RED: '#ef4444',
	GRAY: '#e5e7eb',
};

export const getCountdownInitialState = (endTime: number | undefined, duration: number, autoStart: boolean, persist: boolean) => {
	if (persist && endTime !== undefined) {
		const timeRemaining = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

		if (timeRemaining > 0) {
			return { timeLeft: timeRemaining, isRunning: true };
		}
		return { timeLeft: 0, isRunning: false };
	}
	return { timeLeft: duration, isRunning: autoStart };
};
